import { VcsProvider } from "types/generated";
import { HUMANIZE_PROVIDER } from "constants/vcsProviders";
import { VCS_PROVIDERS_ICONS } from "constants/providerIcons";

import MetaInfoListItem from "./Item";

type MetaInfoProviderProps = {
  provider: VcsProvider;
};

const MetaInfoProvider = ({ provider }: MetaInfoProviderProps) => {
  return (
    <MetaInfoListItem icon={VCS_PROVIDERS_ICONS[provider]}>
      {HUMANIZE_PROVIDER[provider]}
    </MetaInfoListItem>
  );
};

export default MetaInfoProvider;
